<template>
  <div class="page"
    :class="{'page-scrolling': isScrolling}">
    <div class="page-primary-container"
      v-if="$slots['page-primary']">
      <slot name="page-primary"></slot>
    </div>
    <div class="page-header-container"
      id="page-header"
      v-if="$slots['page-header']">
      <slot name="page-header"></slot>
    </div>
    <div class="page-body">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isScrolling: false,
      heightOfHeader: 40,
      sticky: 60,
    };
  },
  mounted() {
    const header = document.getElementById('page-header');
    if (header) {
      this.sticky = header.offsetTop;
      this.heightOfHeader = header.offsetHeight + 100;
    }
    window.addEventListener('scroll', this.handleScroll);
  },
  destroyed() {
    window.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    handleScroll() {
      if (window.pageYOffset > (this.sticky + this.heightOfHeader)) {
        this.isScrolling = true;
      } else {
        this.isScrolling = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/variables.scss';
@import '@/assets/scss/themes/layouts/page.scss';
</style>
